import React from "react";

import moment from "moment";
import { Chip } from "@plum-xoxo/admin-dsm";

export const REWARD_TYPES = {
  PAYMENTS: 0,
  XOXO_POINTS: 1,
  XOXO_CODE: 2,
  XOXO_LINK: 3,
  PLUM_PRO: 4,
};
export const MULTI_ADMIN_STATUS_PAYMENTS = [
  {
    label: "Complete",
    value: "Complete",
  },
  // {
  //     label : "Cancelled",
  //     value : "Cancel"
  // },
  {
    label: "Finance Pending",
    value: "Finance pending",
  },
];

export const MULTI_ADMIN_PAYMENT_REPORT_TABLE_CONST_KEYS_FUNDS = [
  {
    name: "reference_id",
    label: "Reference ID",
    value: "Reference ID",
  },

  {
    name: "reason",
    label: "Reason",
    defaultChecked: true,
  },
  {
    name: "status",
    label: "Status",
    defaultChecked: true,
    options: {
      customBodyRender: (value, tableMeta, updateValue) => {
        return (
          <Chip
            label={value}
            style={{
              height: "24px",
            }}
            onClick={() => {}}
            radius={8}
            variant="fill"
          />
        );
      },
    },
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: MULTI_ADMIN_STATUS_PAYMENTS,
        operation: "IS",
      },
    },
  },
  {
    name: "date_added",
    label: "Date (UTC)",
    defaultChecked: true,
    options: {
      customBodyRender: (value) => {
        return moment(value, "YYYY-MM-DD").format("MMM D, YYYY");
      },
      display: true,
    },
    filter: {
      filterType: "date",
      filters: {
        operation: "IS BETWEEN",
        startDate: "",
        endDate: "",
        selected: true,
      },
    },
  },
  { label: " ", name: "action" },
];

export const MULTI_ADMIN_PAYMENT_REPORT_TABLE_CONST_KEYS = [
  {
    name: "date",
    label: "Date (UTC)",
    defaultChecked: true,
    options: {
      customBodyRender: (value) => {
        return moment(value, "YYYY-MM-DD").format("MMM D, YYYY");
      },
      display: true,
    },
    filter: {
      filterType: "date",
      filters: {
        operation: "IS BETWEEN",
        startDate: "",
        endDate: "",
        selected: true,
      },
    },
  },
  {
    name: "reason",
    label: "Reason",
    defaultChecked: true,
  },
  {
    name: "status",
    label: "Status",
    defaultChecked: true,
    options: {
      customBodyRender: (value, tableMeta, updateValue) => {
        return (
          <Chip
            label={value}
            style={{
              height: "24px",
            }}
            onClick={() => {}}
            radius={8}
            variant="fill"
          />
        );
      },
    },
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: MULTI_ADMIN_STATUS_PAYMENTS,
        operation: "IS",
      },
    },
  },
  {
    name: "changed_balance",
    label: "Change in Balance (USD)",
    value: "Change in Balance (USD)",
  },
  {
    name: "closing_balance",
    label: "Resulting Balance (USD)",
    value: "Resulting Balance (USD)",
  },
  // {
  //   name: "type",
  //   label: "Type",
  //   value: "Type",
  //   filter: {
  //     filterType: "",
  //     filters: [
  //       {
  //         operation: "contains",
  //         value: "",
  //         selected: true,
  //       },
  //     ],
  //   },
  // },
  {
    name: "reference_id",
    label: "Reference ID",
    value: "Reference ID",
  },
];

export const MULTI_ADMIN_STATUS_XOXO_CODE = [
  {
    label: "Redeemed",
    value: "Redeemed",
  },
  // {
  //     label : "Unredeemed",
  //     value : "Unredeemed"
  // },
  {
    label: "Partially Redeemed",
    value: "Partially Redeemed",
  },
  // {
  //     label : "Expired",
  //     value : "Expired"
  // },
  {
    label: "Cancelled",
    value: "Cancelled",
  },
  {
    label: "Delivered",
    value: "Delivered",
  },
  {
    label: "Not Delivered",
    value: "Not Delivered",
  },
];

export const MULTI_ADMIN_POINTS_REPORT_TABLE_CONST_KEYS = [
  // {
  //   label: "Bulk Selection",
  //   value: "bulk_selection",
  //   name: "bulk_selection",
  //   defaultChecked: true,
  //   checked: true,
  //   search: false,
  //   sort: false,
  // },
  {
    name: "sales_order_id",
    label: "Order ID",
    value: "sales_order_id",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: false,
    filter: {
      filterType: "inputNumber",
      filters: [
        { operation: "is", value: "", selected: true, key: "sales_order_id" },
      ],
    },
  },
  {
    label: "Recipient Name",
    value: "receiver_name",
    name: "receiver_name",
    defaultChecked: true,
    checked: true,
    search: true,
    sort: true,
    sort_Type: "",
    searchKey: "name",
    filter: {
      filterType: "input",
      filters: [
        { operation: "is", value: "", selected: true, key: "name_is" },
        { operation: "contains", value: "", selected: false, key: "name_like" },
      ],
    },
  },
  {
    label: "Recipient Email",
    value: "receiver_email",
    name: "receiver_email",
    defaultChecked: true,
    checked: true,
    search: true,
    sort: false,
    searchKey: "email",
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "email_is",
        },
      ],
    },
  },
  {
    label: "Recipient Phone",
    value: "receiver_phone_number",
    name: "receiver_phone_number",
    defaultChecked: false,
    checked: false,
    search: true,
    sort: false,
    searchKey: "receiver_phone_number",
    filter: {
      filterType: "inputNumber",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "receiver_phone_number",
        },
      ],
    },
  },
  {
    label: "Reward Sent",
    value: "total_amount_with_currency",
    name: "total_amount_with_currency",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: false,
    filter: {
      filterType: "inputNumber",
      filters: [
        {
          operation: "is lesser than or equals",
          value: "",
          selected: true,
          key: "max_amount",
        },
        {
          operation: "is greater than or equals",
          value: "",
          selected: false,
          key: "min_amount",
        },
        // {operation : "is between",min_amount : "",max_amount : "",selected : true},
      ],
    },
  },
  {
    label: "Redeemed (Points)",
    value: "used_amount_with_currency",
    name: "used_amount_with_currency",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
    options: {
      display: false,
    },
  },
  {
    label: "Sent Date (UTC)",
    value: "generation_date",
    name: "generation_date",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: true,
    sort_Type: "desc",
    options: {
      display: false,
    },
    filter: {
      filterType: "date",
      filters: {
        operation: "is between",
        startDate: "",
        endDate: "",
        selected: true,
      },
    },
  },
  // {
  //     "label" : "Date expiry",
  //     "value" : 'expiry_date',
  //     "defaultChecked" : false,
  //     'checked' : false,
  //     'search' : false,
  //     'sort' : false,
  //     filter : {
  //         "filterType" : "date",
  //         "filters" : {
  //             operation : "is between",
  //             startDate : "",
  //             endDate : "",
  //             selected : true
  //         }
  //     }
  // },
  {
    label: "Last Redeemed On (UTC)",
    value: "last_redemeed",
    name: "last_redemeed",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: true,
    sort_Type: "",
    options: {
      display: false,
    },
    filter: {
      filterType: "date",
      filters: {
        operation: "is between",
        startDate: "",
        endDate: "",
        selected: true,
      },
    },
  },
  {
    label: "Status",
    value: "status",
    name: "status",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: true,
    sort_Type: "",
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: MULTI_ADMIN_STATUS_XOXO_CODE,
        operation: "is",
      },
    },
  },
  {
    label: "Mode of Delivery",
    value: "mode_of_delivery",
    name: "mode_of_delivery",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "Sent By",
    value: "sent_by",
    name: "sent_by",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
    options: {
      display: false,
    },
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: [],
        operation: "is",
      },
    },
  },
  {
    label: "Notes",
    value: "notes",
    name: "notes",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
    options: {
      display: false,
    },
    filter: {
      filterType: "input",
      filters: [
        { operation: "is", value: "", selected: true, key: "notes_is" },
        {
          operation: "contains",
          value: "",
          selected: false,
          key: "notes_like",
        },
      ],
    },
  },
  {
    label: "fdsa",
    value: "fdsa",
    name: "fdsa",

    options: {
      display: false,
      setCellProps: () => ({
        style: {
          position: "sticky",
          left: 0,
          background: "white",
          zIndex: 101,
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          position: "sticky",
          left: 0,
          top: 0, //Incase Header is Fixed
          zIndex: 102,
        },
      }),
    },
  },
];
export const XOXO_POINT_SCHEDULER_CONSTANT = [
  {
    label: "Name",
    name: "name",
    defaultChecked: true,
  },
  {
    label: "Email",
    name: "email",
    defaultChecked: true,
  },
  {
    label: "Phone Number",
    name: "phone_no",
    defaultChecked: true,
  },
  {
    label: "Amount",
    name: "Amount",
    defaultChecked: true,
  },
  {
    label: "Schedule Date (UTC)",
    name: "schedule_date",
    defaultChecked: false,
    checked: true,
  },
  {
    label: "Notes",
    name: "notes",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Status",
    name: "status",
    defaultChecked: false,
    options: {
      customBodyRender: (value, tableMeta, updateValue) => {
        return (
          <Chip
            label={value === 2 ? "Scheduled" : "Cancelled"}
            style={{
              height: "24px",
            }}
            onClick={() => {}}
            radius={8}
            variant="fill"
            color={value === 2 ? "primary" : "error"}
          />
        );
      },
    },
  },
];

export const MULTI_ADMIN_XOXO_CODE_REPORT_TABLE_CONST_KEYS = [
  {
    label: "Bulk Selection",
    value: "bulk_selection",
    name: "bulk_selection",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: false,
    options: {
      display: false,
    },
  },
  {
    label: "Xoxo Code",
    value: "voucher_code",
    name: "voucher_code",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Recipient Name",
    value: "receiver_name",
    name: "receiver_name",
    defaultChecked: true,
    checked: true,
    search: true,
    sort: true,
    sort_Type: "",
    searchKey: "name",
    filter: {
      filterType: "input",
      filters: [
        { operation: "is", value: "", selected: true, key: "name_is" },
        { operation: "contains", value: "", selected: false, key: "name_like" },
      ],
    },
  },
  {
    label: "Recipient Email",
    value: "receiver_email",
    name: "receiver_email",
    defaultChecked: true,
    checked: true,
    search: true,
    sort: false,
    searchKey: "email",
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "email_is",
        },
      ],
    },
  },
  // {
  // 	"label" : "Phone Code",
  //     "value" :  "receiver_phone_code",
  //     "defaultChecked" : false,
  //     "checked" : false
  // },
  {
    label: "Recipient Phone",
    value: "receiver_phone_number",
    name: "receiver_phone_number",
    defaultChecked: false,
    checked: false,
    search: true,
    sort: false,
    options: {
      display: false,
    },
    searchKey: "receiver_phone_number",
    filter: {
      filterType: "inputNumber",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "receiver_phone_number",
        },
      ],
    },
  },
  // {
  //     "label" : "Used",
  //     "value" : 'used_amount_with_currency',
  //     "defaultChecked" : false,
  //     'checked' : false,
  //     'search' : false,
  //     'sort' : false,
  //     // filter : {
  //     //     "filterType" : "inputNumber",
  //     //     "filters" : [{
  //     //         operation : "is between",
  //     //         value1 : "",
  //     //         value2 : "",
  //     //         selected : true
  //     //     }]
  //     // }
  // },
  {
    label: "Value of Code",
    value: "total_amount_with_currency",
    name: "total_amount_with_currency",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: false,

    filter: {
      filterType: "inputNumber",
      filters: [
        {
          operation: "is lesser than or equals",
          value: "",
          selected: true,
          key: "max_amount",
        },
        {
          operation: "is greater than or equals",
          value: "",
          selected: false,
          key: "min_amount",
        },
        // {operation : "is between",min_amount : "",max_amount : "",selected : true},
      ],
    },
  },
  {
    label: "Redeemed",
    value: "used_amount_with_currency",
    name: "used_amount_with_currency",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
    options: {
      display: false,
    },
    key: "Redeemed",
  },
  {
    label: "Sent Date (UTC)",
    value: "generation_date",
    name: "generation_date",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: true,
    sort_Type: "desc",
    filter: {
      filterType: "date",
      filters: {
        operation: "is between",
        startDate: "",
        endDate: "",
        selected: true,
      },
    },
  },
  // {
  //     "label" : "Date expiry",
  //     "value" : 'expiry_date',
  //     "defaultChecked" : false,
  //     'checked' : false,
  //     'search' : false,
  //     'sort' : false,
  //     filter : {
  //         "filterType" : "date",
  //         "filters" : {
  //             operation : "is between",
  //             startDate : "",
  //             endDate : "",
  //             selected : true
  //         }
  //     }
  // },
  {
    label: "Last Redeemed On (UTC)",
    value: "last_redemeed",
    name: "last_redemeed",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: true,
    options: {
      display: false,
    },
    sort_Type: "",
    filter: {
      filterType: "date",
      filters: {
        operation: "is between",
        startDate: "",
        endDate: "",
        selected: true,
      },
    },
  },
  {
    label: "Status",
    value: "status",
    name: "status",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: true,
    sort_Type: "",
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: MULTI_ADMIN_STATUS_XOXO_CODE,
        operation: "is",
      },
    },
  },
  {
    label: "Campaign",
    value: "campaign_name",
    name: "campaign_name",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
    options: {
      display: false,
    },
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: [],
        operation: "is",
      },
    },
  },
  {
    label: "Mode of Delivery",
    value: "mode_of_delivery",
    name: "mode_of_delivery",
    defaultChecked: false,
    checked: false,
    options: {
      display: false,
    },
  },
  {
    label: "Sent By",
    value: "sent_by",
    name: "sent_by",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
    options: {
      display: false,
    },
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: [],
        operation: "is",
      },
    },
  },
  {
    label: "Notes",
    value: "notes",
    name: "notes",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
    options: {
      display: false,
    },
    filter: {
      filterType: "input",
      filters: [
        { operation: "is", value: "", selected: true, key: "notes_is" },
        {
          operation: "contains",
          value: "",
          selected: false,
          key: "notes_like",
        },
      ],
    },
  },
];
export const XOXO_CODE_SCHEDULER_CONSTANT = [
  {
    label: "Name",
    value: "name",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Email",
    value: "email",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Phone Number",
    value: "phone_no",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Amount",
    defaultChecked: true,
    checked: true,
    submodules: {
      code_value: "denomination",
      point_value: "amount",
    },
  },
  {
    label: "Quantity",
    value: "quantity",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Schedule Date (UTC)",
    value: "schedule_date",
    defaultChecked: false,
    checked: true,
  },
  {
    label: "Notes",
    value: "notes",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Status",
    value: "status",
    defaultChecked: false,
    checked: true,
    2: "Scheduled",
    4: "Cancelled",
    0: "Cancelled",
    "4_class": "canceled",
    "2_class": "scheduled",
    "0_class": "canceled",
  },
];
export const XOXO_LINK_STATUS_SEND_TO_SELF = [
  {
    label: "Delivered",
    value: "delivered",
  },
  {
    label: "Redeemed",
    value: "redeemed",
  },
  {
    label: "Cancelled",
    value: "cancelled",
  },
  {
    label: "Partially Redeemed",
    value: "partial_redeemed",
  },
  {
    label: "Expired",
    value: "expired",
  },
];

export const XOXO_LINK_MODE_DELIVERY = [
  {
    label: "Email",
    value: "Email",
    valueSend: "1",
  },
  {
    label: "Sms",
    value: "Sms",
    valueSend: "2",
  },
  {
    label: "Both",
    value: "Both",
    valueSend: "3",
  },
];
export const XOXO_LINK_SENT_TO_SELF_KEYS = [
  {
    label: "Bulk Selection",
    value: "bulk_selection",
    name: "bulk_selection",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: false,
  },
  {
    label: "Batch ID",
    value: "batchId",
    name: "batchId",
    defaultChecked: true,
    checked: true,
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "batchId",
        },
      ],
    },
    key: "batchId",
  },
  {
    label: "Recipient Name",
    value: "recipient_name",
    name: "recipient_name",
    defaultChecked: true,
    checked: true,
    search: true,
    sort: true,
    searchKey: "name",
    sort_Type: "",
    filter: {
      filterType: "input",
      filters: [
        { operation: "contains", value: "", selected: true, key: "name" },
      ],
    },
  },
  {
    label: "Recipient Email",
    value: "recipient_email",
    name: "recipient_email",
    defaultChecked: true,
    checked: true,
    search: true,
    sort: false,
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "emailId",
        },
      ],
    },
  },
  {
    label: "Value of Link",
    value: "denomination_value",
    name: "denomination_value",
    defaultChecked: true,
    checked: true,
    search: false,
  },
  {
    label: "Sent Date (UTC)",
    value: "issued_date",
    name: "issued_date",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: true,
    sort_Type: "desc",
    filter: {
      filterType: "date",
      filters: {
        operation: "is between",
        startDate: "",
        endDate: "",
        selected: true,
      },
    },
  },
  {
    label: "Expiry Date (UTC)",
    value: "expiry_date",
    name: "expiry_date",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
  },
  {
    label: "Status",
    value: "redemption_status",
    name: "redemption_status",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: true,
    sort_Type: "",
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: XOXO_LINK_STATUS_SEND_TO_SELF,
        operation: "is",
      },
    },
  },
  {
    label: "Campaign",
    value: "campaignName",
    name: "campaignName",
    defaultChecked: false,
    checked: false,
    search: false,
  },
  {
    label: "Quantity (Redeemed / Sent)",
    value: "redeemed_links",
    name: "redeemed_links",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Sent By",
    value: "sent_byemail",
    name: "sent_byemail",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
  },
  {
    label: "Notes",
    value: "notes",
    name: "notes",
    defaultChecked: false,
    checked: false,
  },
];

export const XOXO_LINK_STATUS_SEND_TO_FEW = [
  {
    label: "Delivered",
    value: "delivered",
  },
  {
    label: "Redeemed",
    value: "redeemed",
  },
  {
    label: "Cancelled",
    value: "cancelled",
  },
  {
    label: "Expired",
    value: "expired",
  },
];

export const XOXO_LINK_DISTRIBUTED_TABLE_KEYS = [
  {
    label: "Bulk Selection",
    value: "bulk_selection",
    name: "bulk_selection",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: false,
    options: {
      display: false,
    },
  },
  {
    label: "Xoxo Link",
    value: "xoxolink",
    name: "xoxolink",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Recipient Name",
    value: "recipient_name",
    name: "recipient_name",
    defaultChecked: true,
    checked: true,
    search: true,
    sort: true,
    sort_Type: "",
    filter: {
      filterType: "input",
      filters: [
        { operation: "contains", value: "", selected: true, key: "name" },
      ],
    },
  },
  {
    label: "Recipient Email",
    value: "recipient_email",
    name: "recipient_email",
    defaultChecked: true,
    checked: true,
    search: true,
    sort: false,
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "emailId",
        },
      ],
    },
  },
  {
    label: "Recipient Phone",
    value: "recipient_phone",
    name: "recipient_phone",
    defaultChecked: false,
    checked: false,
    search: true,
    sort: false,
    options: {
      display: false,
    },
    filter: {
      filterType: "inputNumber",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "phoneNumber",
        },
      ],
    },
  },
  {
    label: "Value of Link",
    value: "denomination_value",
    name: "denomination_value",
    defaultChecked: true,
    checked: true,
    search: false,
  },
  {
    label: "Sent Date (UTC)",
    value: "issued_date",
    name: "issued_date",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: true,
    sort_Type: "desc",
    filter: {
      filterType: "date",
      filters: {
        operation: "is between",
        startDate: "",
        endDate: "",
        selected: true,
      },
    },
  },
  {
    label: "Expiry Date (UTC)",
    value: "issued_date",
    name: "expiry_date",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
    options: {
      display: false,
    },
  },
  {
    label: "Redemption Date (UTC)",
    value: "redemption_date",
    name: "redemption_date",
    defaultChecked: false,
    checked: false,
    options: {
      display: false,
    },
  },
  {
    label: "Redeemed By",
    value: "redemption_by",
    name: "redemption_by",
    defaultChecked: false,
    checked: false,
    options: {
      display: false,
    },
  },
  {
    label: "Status",
    value: "redemption_status",
    name: "redemption_status",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: true,
    sort_Type: "",
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: XOXO_LINK_STATUS_SEND_TO_FEW,
        operation: "is",
      },
    },
  },
  {
    label: "Campaign",
    value: "campaignName",
    name: "campaignName",
    defaultChecked: false,
    checked: false,
    search: false,
    options: {
      display: false,
    },
  },
  {
    label: "Quantity (Redeemed / Sent)",
    value: "redeemed_links",
    name: "redeemed_links",
    defaultChecked: false,
    checked: false,
    options: {
      display: false,
    },
  },
  {
    label: "Mode of Delivery",
    value: "delivery_method",
    name: "delivery_method",
    defaultChecked: false,
    checked: false,
    options: {
      display: false,
    },
  },
  {
    label: "Sent By",
    value: "sent_byemail",
    name: "sent_byemail",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
    options: {
      display: false,
    },
  },
  {
    label: "Batch ID",
    value: "batchId",
    name: "batchId",
    defaultChecked: false,
    checked: false,
    options: {
      display: false,
    },
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "batchId",
        },
      ],
    },
  },
  {
    label: "Notes",
    value: "notes",
    name: "notes",
    defaultChecked: false,
    checked: false,
    options: {
      display: false,
    },
  },
];
